import React from 'react'
import { VscGithub } from "react-icons/vsc"
import { FaLinkedinIn } from "react-icons/fa"
import { useContext } from 'react'
import { ThemeContext } from '../context/ThemeContext'
const Connection = () => {
    const { Theme } = useContext(ThemeContext)
    return (
        <div className='fixed left-2 bottom-5 lk'>
            <a href='https://github.com/monumarquis' target='_blank'>
                <button className={` animate-bounce  ${Theme === "dark" ? "bg-[#F2AA4CFF]" : "bg-red-400"} bg-transitionlk text-${ Theme === 'dark' ? 'black-400' : "white"} w-16 h-16 mb-1 rounded-full cursor-pointer flex justify-center items-center transition-all`}>
                    <VscGithub className='w-10 h-10' />
                </button>
            </a>
            <a href="https://www.linkedin.com/in/monu-yadav-2003m/" target='_blank'>
                <button className={` animate-bounce  ${Theme === "dark" ? "bg-[#F2AA4CFF]" : "bg-red-400"} bg-transition lk text-${ Theme === 'dark' ? 'black-400' : "white"} w-16 h-16 rounded-full cursor-pointer flex justify-center items-center transition-all`} >
                    <FaLinkedinIn className='w-8 h-8' />
                </button>
            </a>
        </div>
    )
}

export default Connection